import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './Header.css';

const Header = ({ sidebarOpen, onToggleSidebar }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, logout, checkAuth } = useAuth();
  const navigate = useNavigate();

  const notifications = [
    { id: 1, message: 'Nouvelle commande reçue', time: '2 min', unread: true },
    { id: 2, message: 'Utilisateur inscrit', time: '5 min', unread: true },
    { id: 3, message: 'Stock faible sur produit X', time: '1h', unread: false }
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <header className={`admin-header ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <div className="header-left">
        <button className="sidebar-toggle-btn" onClick={onToggleSidebar}>
          <span className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        
      </div>

      <div className="header-right">
        {/* Barre de recherche */}
        <div className="search-container">
          <input 
            type="text" 
            placeholder="Rechercher..." 
            className="search-input"
          />
          <button className="search-btn">🔍</button>
        </div>

        {/* Notifications */}
        <div className="notifications">
          <button className="notification-btn">
            🔔
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>
        </div>

        {/* Profil utilisateur */}
        <div className="user-menu">
          <button 
            className="user-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            {user?.avatar ? (
              <img src={user.avatar} alt={user.username} className="user-avatar-img" />
            ) : (
              <div className="user-avatar">👤</div>
            )}
            <div className="user-info">
              <div className="user-name">{user?.username || 'Utilisateur'}</div>
              <div className="user-role">
                {user?.roles && user.roles.includes('ROLE_ADMIN') ? 'Administrateur' : 
                 user?.roles && user.roles.length > 0 ? 'Utilisateur' : 'Connecté'}
              </div>
            </div>
            <span className="dropdown-arrow">▼</span>
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="dropdown-item">
                <span className="dropdown-icon">👤</span>
                Mon profil
              </div>
              <div 
                className="dropdown-item"
                onClick={() => {
                  navigate('/settings');
                  setShowUserMenu(false);
                }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    navigate('/settings');
                    setShowUserMenu(false);
                  }
                }}
              >
                <span className="dropdown-icon">⚙️</span>
                Paramètres
              </div>
              <div className="dropdown-divider"></div>
              <div
                className="dropdown-item logout"
                onClick={() => { logout(); setShowUserMenu(false); }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { logout(); setShowUserMenu(false); } }}
              >
                <span className="dropdown-icon">🚪</span>
                Déconnexion
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
